import { render, staticRenderFns } from "./StartReportingCaseComponent.vue?vue&type=template&id=fe118a66&"
import script from "./StartReportingCaseComponent.vue?vue&type=script&lang=js&"
export * from "./StartReportingCaseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports